exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paper-canvas_paper-canvas_1y588 {\n    top: 1px; /* leave room for the border */\n    left: 1px;\n    width: calc(100% - 2px);\n    height: calc(100% - 2px);\n    margin: auto;\n    position: absolute;\n    background-color: #D9E3F2;\n}\n[data-paint-theme=\"dark\"] .paper-canvas_paper-canvas_1y588 {\n    background-color: #222;\n}\n", ""]);

// exports
exports.locals = {
	"paper-canvas": "paper-canvas_paper-canvas_1y588",
	"paperCanvas": "paper-canvas_paper-canvas_1y588"
};